module.exports = __webpack_public_path__ + "9350954d7a1ac86b1672223443e93649.png";